import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  SigninContainer,
  SigninWrapper,
  SigninP,
  SigninInput,
  SigninButton,
  SigninTitle,
  SigninSubtitle,
  Divider,
  PasswordRow,
  EyeButton,
  BottomText,
  BrandLogo,
} from "./SigninElements";
import logo from "../../images/logo (6).jpg";

const Signin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/signin`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (result.success) {
        toast.success(result.message);
        localStorage.setItem('userEmail', result.user.email);
        localStorage.setItem('authToken', result.user.token);
        navigate('/books');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error("Error during login:", error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SigninContainer>
      <SigninWrapper>
        <BrandLogo>
          <img src={logo} alt="CRME Logo" />
        </BrandLogo>
        <SigninTitle>Welcome Back</SigninTitle>
        <SigninSubtitle>Sign in to your CRME account</SigninSubtitle>
        <Divider />

        <form onSubmit={handleSubmit}>
          <SigninP>Email</SigninP>
          <SigninInput
            type="email"
            id="email"
            name="email"
            placeholder="Enter your email"
            value={data.email}
            onChange={handleOnChange}
            required
          />

          <SigninP>Password</SigninP>
          <PasswordRow>
            <SigninInput
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              placeholder="Enter your password"
              value={data.password}
              onChange={handleOnChange}
              required
            />
            <EyeButton onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </EyeButton>
          </PasswordRow>

          <div style={{ textAlign: 'right', marginBottom: '24px' }}>
            <Link to="/forgot_password" style={{ color: '#14b8a6', fontSize: '13px', textDecoration: 'none', fontWeight: '500' }}>
              Forgot Password?
            </Link>
          </div>

          <SigninButton type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </SigninButton>
        </form>

        <BottomText>
          Don't have an account? <Link to="/signup">Sign Up</Link>
        </BottomText>
      </SigninWrapper>
    </SigninContainer>
  );
};

export default Signin;
